import { render, staticRenderFns } from "./storeIcon.vue?vue&type=template&id=84476bc8&scoped=true"
import script from "./storeIcon.vue?vue&type=script&lang=js"
export * from "./storeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84476bc8",
  null
  
)

export default component.exports